// extracted by mini-css-extract-plugin
export default {"modalBodyContainer":"WhatsCoveredModal_modalBodyContainer__0BqWu"};